import { render, staticRenderFns } from "./LayoutController.vue?vue&type=template&id=04636f7f"
import script from "./LayoutController.vue?vue&type=script&lang=js"
export * from "./LayoutController.vue?vue&type=script&lang=js"
import style0 from "./LayoutController.vue?vue&type=style&index=0&id=04636f7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports